import axios from "axios";

// WayaQuick website assistant (public, no auth).
const ASSISTANT_URL =
  "https://n8n.staging.wayabank.ng/webhook/waya/website-assistant";

// SECURITY, PLEASE READ:
// This secret ships inside the public JS bundle, so anyone who opens the site
// can read it from the network tab and call the webhook directly. Fine for
// staging; before production, route this through your own backend/serverless
// proxy that adds the header server-side and remove it from the frontend.
const WAYA_SECRET =
  "bf5b7936e675a476055ea072dc5a3ac8639f27a5fe6e1d00875c462f2bd2955f";

const SESSION_KEY = "waya_assistant_session_id";

// localStorage persists across reloads and return visits (per-device).
function getStoredSessionId() {
  try {
    return localStorage.getItem(SESSION_KEY) || null;
  } catch (e) {
    return null;
  }
}

function storeSessionId(id) {
  try {
    if (id) localStorage.setItem(SESSION_KEY, id);
  } catch (e) {
    /* storage unavailable, ignore */
  }
}

// Called by "start new chat" to drop the thread server-side too.
export function resetSession() {
  try {
    localStorage.removeItem(SESSION_KEY);
  } catch (e) {
    /* ignore */
  }
}

function pickString(obj, keys) {
  for (var i = 0; i < keys.length; i++) {
    var v = obj ? obj[keys[i]] : null;
    if (typeof v === "string" && v.trim() !== "") return v;
  }
  return "";
}

/**
 * Send one message to the assistant.
 * Confirmed contract: request { message, session_id }, response
 * { reply, suggested_questions, session_id, ... }.
 * We send the session_id we last received (if any) and adopt whatever the
 * server returns, so the conversation threads instead of restarting.
 *
 * @param {string} message
 * @returns {Promise<{ answer: string, suggestions: string[] }>}
 */
export async function sendAssistantMessage(message) {
  var body = { message: message };
  var sid = getStoredSessionId();
  if (sid) body.session_id = sid; // continue the existing thread when we have one

  var res = await axios.post(ASSISTANT_URL, body, {
    headers: {
      "Content-Type": "application/json",
      "x-waya-secret": WAYA_SECRET,
    },
  });

  var data = res && res.data;
  // n8n may return an object or a single-item array; normalise both.
  var payload = Array.isArray(data) ? data[0] || {} : data || {};

  // Adopt the canonical session id so the NEXT turn stays in this conversation.
  if (payload.session_id) storeSessionId(payload.session_id);

  var answer = pickString(payload, [
    "reply",
    "answer",
    "response",
    "output",
    "text",
    "message",
  ]);

  var suggestions = [];
  if (Array.isArray(payload.suggested_questions)) {
    suggestions = payload.suggested_questions;
  } else if (Array.isArray(payload.suggestedQuestions)) {
    suggestions = payload.suggestedQuestions;
  }

  return {
    answer: answer || "Sorry, I didn't get a response. Please try again.",
    suggestions: suggestions,
  };
}